if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
        // Update the add to cart button price after quantity is reset
        const variantPicker = this.closest('[data-section]')?.querySelector('variant-selects, variant-radios');
        if (variantPicker && typeof variantPicker.updateAddButtonPrice === 'function') {
          variantPicker.updateAddButtonPrice();
        }
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// Product Exclusive Functionality ================================

document.addEventListener('DOMContentLoaded', function() {
  var videoContainers = document.querySelectorAll(".sticky-video");

  videoContainers.forEach(videoContainer => {
    var playButton = videoContainer.querySelector('.play-button');
    var closeButton = document.createElement('div');
    closeButton.className = 'close-button';
    closeButton.innerText = '×';
    videoContainer.querySelector('.video-item').appendChild(closeButton);
    
    var video = videoContainer.querySelector('video');
    video.muted = true; // Mute video by default
    video.play(); // Start playing video on load

    var isExpanded = false; // Track if video has been expanded

    videoContainer.addEventListener('click', function(event) {
      // Handle expand/collapse
      if (!isExpanded) {
        videoContainer.classList.add('expanded');
        video.muted = false; // Enable sound when expanded
        isExpanded = true;
        playButton.style.opacity = video.paused ? 1 : 0; // Show play button if video is paused
      } else {
        // Pause the video if it's expanded and clicked
        if (video.paused) {
          video.play();
          playButton.classList.add('play');
          playButton.style.opacity = 0; // Hide play button when playing
        } else {
          video.pause();
          playButton.classList.remove('play');
          playButton.style.opacity = 1; // Show play button when paused
        }
      }
      event.stopPropagation(); // Prevent click event from bubbling up
    });
    
    // Handle play/pause button click
    playButton.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevent click event from bubbling up to videoContainer
      if (video.paused) {
        video.play();
        this.classList.add('play');
        this.style.opacity = 0; // Hide play button when playing
      } else {
        video.pause();
        this.classList.remove('play');
        this.style.opacity = 1; // Show play button when paused
      }
    });
    
    // Handle close button click
    closeButton.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevent click event from bubbling up to videoContainer
      video.pause();
      videoContainer.style.display = 'none';
    });
    
    // Ensure play button visibility matches video state
    video.addEventListener('play', function() {
      if (isExpanded) {
        playButton.classList.add('play');
        playButton.style.opacity = 0; // Hide play button when playing
      }
    });

    video.addEventListener('pause', function() {
      if (isExpanded) {
        playButton.classList.remove('play');
        playButton.style.opacity = 1; // Show play button when paused
      }
    });
  });


  const readMoreBtns = document.querySelectorAll('.read-more-btn');
  readMoreBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const wrapper = this.previousElementSibling;
      wrapper.classList.toggle('expanded');
      
      if (wrapper.classList.contains('expanded')) {
        this.textContent = 'Read Less';
      } else {
        this.textContent = 'Read More';
      }
    });
  });

});


// Custom: Append sale badge to OKE reviews block

const customTag = document.querySelector('.custom-tag');
const okeReviews = document.querySelector('[data-oke-star-rating]');

if (customTag && okeReviews) {
  // Move it initially
  if (!okeReviews.contains(customTag)) {
    okeReviews.appendChild(customTag);
  }

  // Watch for changes in the reviews block
  const observer = new MutationObserver(() => {
    if (!okeReviews.contains(customTag)) {
      okeReviews.appendChild(customTag);
    }
  });

  observer.observe(okeReviews, { childList: true, subtree: true });
}